import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { deleteCorrBankAction } from "../action/deleteCorrBankAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const deleteCorrBankSlice = createSlice({
  name: "deleteCorrBankSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteCorrBankAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCorrBankAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteCorrBankAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const deleteCorrBankReducer = deleteCorrBankSlice.reducer;
